/* @flow */
import ConfirmDialog from 'components/ConfirmDialog.jsx';
import Group from 'entities/Group';
import GroupActions from 'groups/actions/GroupActions';
import React from 'react';
import ToastActions from 'actions/ToastActions';

class AddGroupOwnerModalConfirm extends React.Component {
  static propTypes = {
    group: React.PropTypes.instanceOf(Group).isRequired,
    checkedIds: React.PropTypes.arrayOf(React.PropTypes.number).isRequired,
    userName: React.PropTypes.string,
    onFinish: React.PropTypes.func,
  };

  addOwners = () => {
    const successMessage = 'Class ' +
      (this.props.checkedIds.length > 1 ? 'owners' : 'owner') + ' added';

    if (this.props.onFinish) {
      this.props.onFinish();
    }

    GroupActions.promoteGroupMemberships(this.props.group, this.props.checkedIds).then(
      () => ToastActions.showSuccessToast(successMessage),
      () => ToastActions.showDefaultErrorToast()
    );
  };

  render() {
    const ownersCount = this.props.checkedIds.length;
    let confirmTitle;
    if (ownersCount > 1) {
      confirmTitle = `Are you sure you want to add ${ownersCount} class owners?`;
    } else if (this.props.userName) {
      confirmTitle = `Are you sure you want to add ${this.props.userName} as class owner?`;
    } else {
      confirmTitle = 'Are you sure you want to add a class owner?';
    }

    return (
      <ConfirmDialog
        eventScreenName="AddGroupOwnerModalConfirm"
        {...this.props}
        title={confirmTitle}
        subtext={
          'All class owners have the same controls. Once added, an owner can’t be removed.'
        }
        actionButtonText="Add"
        cancelButtonText="Cancel"
        onConfirm={this.addOwners}
      />
    );
  }
}

export default AddGroupOwnerModalConfirm;



// WEBPACK FOOTER //
// ./src/groups/components/AddGroupOwnerModalConfirm.jsx